/**
 * CODE_COMMENTS_31
 * CODE_COMMENTS_58
 */

export const REPORT_KEG_FILLS_FIELD_ARRAY_NAME = 'kegFills'
